export class ImageCompare {
  container: HTMLElement;
  before: HTMLImageElement;
  after: HTMLImageElement;
  slider: HTMLInputElement;
  thumb: HTMLElement;

  constructor(container) {
    this.container = container;
    this.before = this.container.querySelector('[data-image-compare-image="before"]');
    this.after = this.container.querySelector('[data-image-compare-image="after"]');
    this.slider = this.container.querySelector('[data-image-compare-slider]');
    this.thumb = this.container.querySelector('[data-image-compare-thumb]');
    this.init();
  }

  init() {
    this.slider.addEventListener("input", () => {
      //@ts-ignore
      const value: number = this.slider.value / 10;
      this.before.style.width = value + '%';
      this.after.style.width = (100 - value) + '%';
      this.thumb.style.left = value + '%';
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll<HTMLElement>('[data-image-compare]').forEach((item: HTMLElement) => {
    new ImageCompare(item);
  });
});
